<template>
  <v-container fluid class="px-0 mx-0">
    <!-- Temperature Chart -->
    <template v-if="!loading">
      <highcharts
        v-if="!loading"
        ref="highchart"
        :constructor-type="'stockChart'"
        :options="temperatureChartOptions"
      ></highcharts>

      <v-col class="text-center">
        <span style="color:rgb(74 157 74)">SEC</span> : Sèche
        | <span class="mx-3" style="color:rgb(0 112 255)">EAU</span> : Mouillé
        | <span class="mx-3" style="color:rgb(50 173 187)">GLA</span> : Neige
        | <span class="mx-3" style="color:rgb(255 143 0)">G/E</span> : Neige fondu
        | <span class="mx-3" style="color:rgb(250 145 255)">ROS</span> : Humide
        | <span class="mx-3" style="color:rgb(255  140  0)">G/F</span> : Neige et Verglas
        | <span class="mx-3" style="color:rgb(255  25  0)">VERG</span> : Verglas
        | <span class="mx-3" style="color:rgb(208  18  198)">E/V</span> : Eau et Verglas
      </v-col>

      <highcharts
        v-if="!loading"
        ref="highchart2"
        :constructor-type="'stockChart'"
        :options="rainChartOptions"
      ></highcharts>

      <highcharts
        v-if="!loading"
        ref="highchart4"
        :constructor-type="'stockChart'"
        :options="pressureChartOptions"
      ></highcharts>

    </template>
    <template v-else>
      <v-skeleton-loader type="card"></v-skeleton-loader>
    </template>
  </v-container>
</template>

<script>
/* eslint-disable */

import { ref } from "vue";

import moment from "moment";

// Components

// Highcharts
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import stockInit from "highcharts/modules/stock";

// API helper
import api from "../../api";

import cardinals from "../../cardinals";
import { iconUrl } from "../../iconUrl";

import axios from 'axios';

// Load the full build.
var _ = require("lodash");


var self = this;

stockInit(Highcharts);


export default {
  name: "Prévisions",

  components: {
    highcharts: Chart,
  },

  data: () => ({
    loading: true,
    forecasts: [],
  }),

  computed: {
    // Temperature Chart Options
    temperatureChartOptions() {
      let series = [];
      let tmaxData = [];
      let troadData = [];
      let tsData = [];
      let roadCond = [];
      let dewPiont = [];
      let forecasts = this.forecasts;

      let formatIcon = this.formatIcon;

      let night = [];
      let actualNight = {};

      let minA = [];
      let maxA = [];
      let min = 0;
      let max = 0;

      // Loop trough forecasts array and push [time, value]
      forecasts.forEach((previ, index) => {
        tmaxData.push({
          x: moment.utc(previ.date).unix() * 1000,
          y: +previ.tmax,
        });

        troadData.push({
          x: moment.utc(previ.date).unix() * 1000,
          y: +previ.road_temp,
        });

        roadCond.push({
          x: moment.utc(previ.date).unix() * 1000,
          y: +previ.road_cond,
        });

        tsData.push({
          x: moment.utc(previ.date).unix() * 1000,
          y: +previ.tmax + 10,
          marker: {
            symbol: `url(${formatIcon(index)})`,
            height: 30,
            width: 30,
          },
        });

        dewPiont.push({
          x: moment.utc(previ.date).unix() * 1000,
          y: +previ.dpt2m,
        });

        minA.push(previ.tmax);
        minA.push(previ.dpt2m);
        minA.push(previ.road_temp);

        maxA.push(previ.tmax);
        maxA.push(previ.road_temp);
        maxA.push(previ.dpt2m);

        min = _.min(minA) - 5;
        max = _.max(maxA) + 20;

        if (previ.is_night && !actualNight.from) {
          actualNight.color = "#E2E2E2";
          actualNight.from = moment.utc(previ.date).unix() * 1000;
        } else if (
          (!previ.is_night && actualNight.from) ||
          (actualNight.from && index + 1 === forecasts.length)
        ) {
          actualNight.to = moment.utc(forecasts[index - 1].date).unix() * 1000;

          night.push(actualNight);
          actualNight = {};
        }
      });
      // Push data into series array
      series.push({
        showInLegend: false,
        color: "#ff0000",
        data: tmaxData,
        yAxis: 0,
        name: this.$t("forecasts.temperatureChart.title1"),
        states: {
          hover: {
            enabled: false,
          },
        },
      });

      series.push({
        color: "#ff0000",
        data: tsData,
        type: "scatter",
        yAxis: 0,
        name: this.$t("forecasts.temperatureChart.title1"),
        states: {
          hover: {
            enabled: false,
          },
        },
      });

      series.push({
        color: "#1dff00",
        data: dewPiont,
        yAxis: 1,
        name: this.$t("forecasts.temperatureChart.title2"),
        states: {
          hover: {
            enabled: false,
          },
        },
      });
      series.push({
        color: "#934545",
        data: troadData,
        yAxis: 1,
        name: this.$t("road_temp"),
        states: {
          hover: {
            enabled: false,
          },
        },
      });
      series.push({
        color: "rgba(0,0,0,0)",
        data: roadCond,
        type: "column",
        yAxis: 0,
        name: this.$t("road_cond"),
        states: {
          hover: {
            enabled: false,
          },
        },
      });


      // Return the chart options for axis
      return {
        tooltip: {
          formatter() {
            let tooltipArray = [
              moment(this.x).format("Do MMMM YYYY[,] H[h]mm"),
            ];

            this.points.forEach((point, index) => {
              if(point.series.name != $t("road_cond"))
              {
                tooltipArray.push(
                  point.series.name + ": " + point.y.toFixed(1) + "</b>"
                );
              }
            });

            return tooltipArray;
          },
        },
        xAxis: {
          type: "datetime",
          labels: {
            formatter: (e) => {
              if (new Date(e.value).getHours() === 0) {
                return moment(e.value).format("D MMM");
              }
              return moment(e.value).format("HH[h]");
            },
            style: {
              fontSize: "10px",
            },
          },
          events: {
            setExtremes: this.syncExtremes,
          },
          plotBands: night,
          tickPositions: this.tickArray,
        },
        yAxis: [
          {
            tickAmount: 10,
            tickInterval: 10,
            min: min,
            max: max,
            labels: {
              format: "{value}",
            },
            title: {
              text: this.$t("forecasts.temperatureChart.legend1"),
            },
            opposite: false,
          },
          {
            tickAmount: 10,
            tickInterval: 10,
            min: min,
            max: max,
            labels: {
              format: "{value}",
            },
            title: {
              text: this.$t("forecasts.temperatureChart.legend1"),
            },
          },
          {
            tickAmount: 10,
            tickInterval: 10,
            min: min,
            max: max,
            labels: {
              enabled: false,
            },
            title: {
              text: this.$t("forecasts.temperatureChart.legend2"),
            },
          },
          {

            tickAmount: 10,
            tickInterval: 10,
            min:min,
            max:max,
            labels: {
              enabled: false,
            },
            title: {
              text: this.$t("road_cond"),
            },
          },
        ],
        // Labels Options
        plotOptions: {
          column: {
            dataLabels: {
              useHTML: true,
              enabled: true,
              verticalAlign: "top",
              align: "center",
              x: 0, // Offset des points
              y: 0,
              padding: 0,
              formatter: function (e) {
                function roadCondToTitle(e) {
                  let text = null;
                  e = parseInt(e);
                  switch (e) {
                    case 1:
                    text = "SEC";
                    break;
                    case 2:
                    text = "EAU";
                    break;
                    case 3:
                    text = "GLA";
                    break;
                    case 4:
                    text = "G/E";
                    break;
                    case 5:
                    text = "ROS";
                    break;
                    case 6:
                    text = "G/F";
                    break;
                    case 7:
                    text = "VERG";
                    break;
                    case 8:
                    text = "E/V";
                    break;
                  }
                  return text;
                }
                function roadCondToColor(e) {
                  let color = null;

                  e = parseInt(e);
                  switch (e) {
                    case 1:
                      color = "74 157 74";
                      break;
                    case 2:
                      color = "0 112 255";
                      break;
                    case 3:
                      color = "50 173 187";
                      break;
                    case 4:
                      color = "255 143 0";
                      break;
                    case 5:
                      color = "250,145,255";
                      break;
                    case 6:
                      color = "255, 140, 0";
                      break;
                    case 7:
                      color = "255, 25, 0";
                      break;
                    case 8:
                      color = "208, 18, 198";
                      break;
                  }
                  return color;
                }
                return `<span style="color:rgb(${roadCondToColor(this.y)})">${roadCondToTitle(this.y)}</span>`
              },
              style: {
                fontSize: "12px",
              },
            },
          },
          series: {
            dataGrouping: {
              enabled: false,
            },
            states: {
              inactive: {
                opacity: 1,
              },
            },
          },
          line: {
            dataLabels: {
              useHTML: true,
              enabled: false,
              // allowOverlap: true,
              verticalAlign: "top",
              align: "center",
              x: 0, // Offset des points
              y: -22,
              padding: 0,
              style: {
                fontSize: "12px",
              },
            },
            enableMouseTracking: true,
          },
        },
        chart: {
          animation: false,
        },
        time: {
          useUTC: false,
        },
        series,
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: true,
        },
        scrollbar: {
          enabled: false,
        },
        legend: {
          align: "center",
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: "center",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                },
                yAxis: [
                  {
                    labels: {
                      align: "left",
                      x: 0,
                      y: -5,
                    },
                    title: {
                      text: null,
                    },
                  },
                  {
                    labels: {
                      align: "left",
                      x: 0,
                      y: -5,
                    },
                    title: {
                      text: null,
                    },
                  },
                ],
                subtitle: {
                  text: null,
                },
                credits: {
                  enabled: false,
                },
              },
            },
          ],
        },
      };
    },


    rainChartOptions() {
      let series = [];
      let rain = [];
      let snow = [];
      let rainMin = [];
      let etp = [];
      let forecasts = this.forecasts;

      let night = [];
      let actualNight = {};
      
      let max = 10;
      let min = 0;

      // Loop trough forecasts array and push [time, value]
      forecasts.forEach((previ, index) => {
        // Rain or Snow data
        if (previ.csnowsfc > 0) {
          snow.push([
            moment.utc(previ.date).unix() * 1000,
            Math.round(((previ.apcpsfc * previ.csnowsfc * 8) / 10) * 10) / 10,
          ]);

          if (previ.csnowsfc > max)
            max = Math.ceil(((previ.apcpsfc * previ.csnowsfc * 8) / 10) * 10);
        } else {
          rain.push([
            moment.utc(previ.date).unix() * 1000,
            Math.round(+previ.apcpsfc * 10) / 10,
          ]);
          if (previ.apcpsfc > max) max = Math.ceil(previ.apcpsfc);
        }

        etp.push([
          moment.utc(previ.date).unix() * 1000,
          parseFloat(-previ.etp),
        ]);

        if (-previ.etp < min) min = min = -previ.etp;

        // Humidity
        rainMin.push([
          moment.utc(previ.date).unix() * 1000,
          Math.floor(previ.rhmin),
        ]);

        // Night data
        if (previ.is_night && !actualNight.from) {
          actualNight.color = "#E2E2E2";
          actualNight.from = moment.utc(previ.date).unix() * 1000;
        } else if (
          (!previ.is_night && actualNight.from) ||
          (actualNight.from && index === forecasts.length - 1)
        ) {
          actualNight.to =
            moment(forecasts[index - 1].date)
              .utcOffset(2)
              .unix() * 1000;

          night.push(actualNight);
          actualNight = {};
        }
      });

      // Push data into series array
      if (snow.length > 0) {
        series.push({
          type: "column",
          name: "Neige (cm)",
          data: snow,
          color: "grey",
          yAxis: 2,
        });
      }
      series.push({
        type: "column",
        name: this.$t("forecasts.rainChart.title1"),
        data: rain,
        yAxis: 0,
      });
      series.push({
        data: rainMin,
        color: "#030D6B",
        name: this.$t("forecasts.rainChart.title3"),
        yAxis: 1,
      });

      // Return the chart options for axis
      return {
        tooltip: {
          formatter() {
            let tooltipArray = [
              moment(this.x).format("Do MMMM YYYY[,] H[h]mm"),
            ];

            this.points.forEach((point, index) => {
              point.series.name === "ETP (mm)"
                ? tooltipArray.push(
                    point.series.name + ": " + point.y.toFixed(1) * -1 + "</b>"
                  )
                : tooltipArray.push(
                    point.series.name + ": " + point.y.toFixed(1) + "</b>"
                  );
            });

            return tooltipArray;
          },
        },
        xAxis: {
          type: "datetime",
          labels: {
            formatter: (e) => {
              if (new Date(e.value).getHours() === 0) {
                return moment(e.value).format("D MMM");
              }
              return moment(e.value).format("HH[h]");
            },
            style: {
              fontSize: "10px",
            },
          },
          events: {
            setExtremes: this.syncExtremes,
          },
          plotBands: night,
          tickPositions: this.tickArray,
        },
        yAxis: [
          {
            tickAmount: 7,
            min: 0,
            max: max,
            labels: {
              format: "{value:.0f}",
            },
            title: {
              text: "Pluie",
            },
            opposite: false,
          },
          {
            tickAmount: 3,
            min: 0,
            max: 100,
            labels: {
              format: "{value:.0f}",
            },
            title: {
              text: this.$t("forecasts.rainChart.legend2"),
            },
          },
          {
            min: 0,
            max: 10,
            labels: {
              enabled: false,
              format: "{value:.0f}",
            },
            opposite: false,
          },
        ],
        plotOptions: {
          series: {
            showInNavigator: true,
          },
          column: {
            dataLabels: {
              verticalAlign: "top",
              x: 0,
              y: -22,
              padding: 0,
              align: "center",
              enabled: true,
              style: {
                fontSize: "12px",
              },
              formatter: function () {
                let value = Math.round(this.y * 100) / 100;
                if (value > 0) {
                  return String(value).replaceAll(".", ",");
                } else {
                  return "";
                }
              },
            },
            enableMouseTracking: true,
          },
        },

        time: {
          useUTC: false,
        },
        series,
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: true,
        },
        scrollbar: {
          enabled: false,
        },
        legend: {
          align: "center",
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: "center",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                },
                yAxis: [
                  {
                    labels: {
                      align: "left",
                      x: 0,
                      y: -5,
                    },
                    title: {
                      text: null,
                    },
                  },
                  {
                    labels: {
                      align: "left",
                      x: 0,
                      y: -5,
                    },
                    title: {
                      text: null,
                    },
                  },
                  {
                    labels: {
                      align: "left",
                      x: 0,
                      y: -5,
                    },
                    title: {
                      text: null,
                    },
                  },
                ],
                subtitle: {
                  text: null,
                },
                credits: {
                  enabled: false,
                },
              },
            },
          ],
        },
      };
    },

    windChartOptions() {
      let series = [];
      let windSpeed = [];
      let gust = [];
      let forecasts = this.forecasts;
      let getArrow = this.getArrow;

      // Set default timezone
      // moment.tz.setDefault;

      let night = [];
      let actualNight = {};

      let max = 0;

      // Loop trough forecasts array and push [time, value]
      forecasts.forEach((previ, index) => {
        windSpeed.push([
          moment.utc(previ.date).unix() * 1000,
          Math.floor(previ.wind_speed * 3.6),
        ]);

        gust.push([
          moment.utc(previ.date).unix()  * 1000,
          Math.ceil(previ.gustsfc * 3.6),
        ]);

        if (previ.gustsfc * 3.6 > max) max = Math.ceil(previ.gustsfc * 3.6);

        if (previ.is_night && !actualNight.from) {
          actualNight.color = "#E2E2E2";
          actualNight.from = moment.utc(previ.date).unix() * 1000;
        } else if (
          (!previ.is_night && actualNight.from) ||
          (actualNight.from && index === forecasts.length - 1)
        ) {
          actualNight.to = moment.utc(forecasts[index - 1].date).unix() * 1000;

          night.push(actualNight);
          actualNight = {};
        }
      });

      max += 10;

      // Push data into series array
      series.push({
        color: "#0037ff",
        data: windSpeed,
        yAxis: 0,
        name: this.$t("forecasts.windChart.title1"),
        dataLabels: {
          align: "top",
          formatter() {
            if (this.point.index % 3 === 0)
              return `<p><i class="fas fa-long-arrow-alt-up"
                    style="margin-left:5px;transform: rotate(${getArrow(
                      cardinals(Math.round(forecasts[this.point.index].dir + 180))
                    )}deg)"
                  ></i></p>`;
          },
        },
      });

      series.push({
        color: "#ff0000",
        data: gust,
        yAxis: 1,
        name: this.$t("forecasts.windChart.title2"),
        dataLabels: {
          enabled: false,
        },
      });

      // Return the chart options for axis
      return {
        tooltip: {
          formatter() {
            let tooltipArray = [
              moment(this.x).format("Do MMMM YYYY[,] H[h]mm"),
            ];

            this.points.forEach((point, index) => {
              tooltipArray.push(
                point.series.name + ": " + point.y.toFixed(1) + "</b>"
              );
            });

            return tooltipArray;
          },
        },
        xAxis: {
          type: "datetime",
          // tickInterval: 1 * 36e5,
          // gridLineWidth: 1,
          labels: {
            formatter: (e) => {
              if (new Date(e.value).getHours() === 0) {
                return moment(e.value).format("D MMM");
              }
              return moment(e.value).format("HH[h]");
            },
            style: {
              fontSize: "10px",
            },
          },
          events: {
            setExtremes: this.syncExtremes,
          },
          plotBands: night,
          tickPositions: this.tickArray,
        },
        yAxis: [
          {
            tickAmount: 3,
            tickInterval: 10,
            min: 0,
            max: max,
            labels: {
              format: "{value}",
            },
            opposite: false,
            title: {
              text: this.$t("forecasts.windChart.legend1"),
            },
          },
          {
            tickAmount: 3,
            tickInterval: 10,
            min: 0,
            max: max,
            labels: {
              format: "{value}",
            },
            title: {
              text: this.$t("forecasts.windChart.legend1"),
            },
          },
          {
            tickAmount: 3,
            tickInterval: 10,
            min: 0,
            max: max,
            labels: {
              enabled: false,
            },
            title: {
              text: this.$t("forecasts.windChart.legend2"),
            },
          },
        ],
        // Labels Options
        plotOptions: {
          line: {
            dataLabels: {
              useHTML: true,
              enabled: true,
              verticalAlign: "top",
              align: "center",
              x: 0, // Offset des points
              y: -22,
              padding: 0,
              style: {
                fontSize: "12px",
              },
            },
            enableMouseTracking: true,
          },
        },
        // Sizing for Puppeteer
        // chart: {
        //   height: 180,
        // },

        time: {
          useUTC: false,
        },
        series,
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: true,
        },
        scrollbar: {
          enabled: false,
        },
        legend: {
          align: "center",
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: "center",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                },
                yAxis: {
                  labels: {
                    align: "left",
                    x: 0,
                    y: -5,
                  },
                  title: {
                    text: null,
                  },
                },
                subtitle: {
                  text: null,
                },
                credits: {
                  enabled: false,
                },
              },
            },
          ],
        },
      };
    },

    pressureChartOptions() {
      let series = [];
      let pressure = [];
      let forecasts = this.forecasts;

      // Set default timezone
      // moment.tz.setDefault;

      let night = [];
      let actualNight = {};

      let max = 0;
      let min = 10000

      // Loop trough forecasts array and push [time, value]
      forecasts.forEach((previ, index) => {
        pressure.push([
          moment.utc(previ.date).unix() * 1000,
          Math.floor(previ.prmslmsl),
        ]);
        if(parseInt(previ.prmslmsl) > max)
        {
          max = previ.prmslmsl
        }
        if(parseInt(previ.prmslmsl) < min)
        {
          min = previ.prmslmsl
        }

        // if (previ.prmslmsl > max) max = Math.ceil(previ.prmslmsl);

        if (previ.is_night && !actualNight.from) {
          actualNight.color = "#E2E2E2";
          actualNight.from = moment.utc(previ.date).unix() * 1000;
        } else if (
          (!previ.is_night && actualNight.from) ||
          (actualNight.from && index === forecasts.length - 1)
        ) {
          actualNight.to =
            moment(forecasts[index - 1].date)
              .utcOffset(2)
              .unix() * 1000;

          night.push(actualNight);
          actualNight = {};
        }
      });


      // Push data into series array
      series.push({
        color: "#0037ff",
        data: pressure,
        yAxis: 0,
        name: this.$t("forecasts.pressureChart.title1"),
      });

      // Return the chart options for axis
      return {
        tooltip: {
          formatter() {
            let tooltipArray = [
              moment(this.x).format("Do MMMM YYYY[,] H[h]mm"),
            ];

            this.points.forEach((point, index) => {
              tooltipArray.push(
                point.series.name + ": " + point.y.toFixed(1) + "</b>"
              );
            });

            return tooltipArray;
          },
        },
        xAxis: {
          type: "datetime",
          // tickInterval: 1 * 36e5,
          // gridLineWidth: 1,
          labels: {
            formatter: (e) => {
              if (new Date(e.value).getHours() === 0) {
                return moment(e.value).format("D MMM");
              }
              return moment(e.value).format("HH[h]");
            },
            style: {
              fontSize: "10px",
            },
          },
          events: {
            setExtremes: this.syncExtremes,
          },
          plotBands: night,
          tickPositions: this.tickArray,
        },
        yAxis: [
          {
            tickAmount: 3,
            tickInterval: 10,
            max: max,
            min:min,
            labels: {
              format: "{value}",
            },
            opposite: false,
            title: {
              text: this.$t("forecasts.pressureChart.legend1"),
            },
          },
          {
            tickAmount: 3,
            tickInterval: 10,
            max: max,
            min: min,
            labels: {
              format: "{value}",
            },
            title: {
              text: this.$t("forecasts.pressureChart.legend1"),
            },
          },
        ],
        // Labels Options
        plotOptions: {
          line: {
            // dataLabels: {
            //   // useHTML: true,
            //   enabled: true,
            //   verticalAlign: "top",
            //   align: "center",
            //   x: 0, // Offset des points
            //   y: -22,
            //   padding: 0,
            //   style: {
            //     fontSize: "12px",
            //   },
            // },
            enableMouseTracking: true,
          },
        },
        // Sizing for Puppeteer
        // chart: {
        //   height: 180,
        // },

        time: {
          useUTC: false,
        },
        series,
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: true,
        },
        scrollbar: {
          enabled: false,
        },
        legend: {
          align: "center",
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: "center",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                },
                yAxis: {
                  labels: {
                    align: "left",
                    x: 0,
                    y: -5,
                  },
                  title: {
                    text: null,
                  },
                },
                subtitle: {
                  text: null,
                },
                credits: {
                  enabled: false,
                },
              },
            },
          ],
        },
      };
    },
    getArrow(str) {
      switch (str) {
        case "N":
          return 0;
        case "NNE":
          return 22.5;
        case "NE":
          return 45;
        case "ENE":
          return 67.5;
        case "E":
          return 90;
        case "ESE":
          return 112.5;
        case "SE":
          return 135;
        case "SSE":
          return 157.5;
        case "S":
          return 180;
        case "SSO":
          return 202.5;
        case "SO":
          return 225;
        case "OSO":
          return 247.5;
        case "O":
          return 270;
        case "ONO":
          return 292.5;
        case "NO":
          return 315;
        case "NNO":
          return 337.5;

        default:
          return "-";
      }
    },

    tickArray() {
      let forecasts = this.forecasts;

      let res = [];

      forecasts.forEach((chunk, index) => {
        if (
          moment.utc(chunk.date).local().hours() === 0 ||
          new moment.utc(chunk.date).local().hours() === 12
        )
          res.push(moment.utc(chunk.date).unix() * 1000);
      });

      return res;
    },
  },

  methods: {
    /**
     * Fetch API, get forecasts & select only wanted time
     */
    async getForecasts() {
      this.loading = true;
      try {
        // let result = await api.forecast.get(this.$route.params.geoname);
        let cityInfo = await api.cities.getinfos(this.$route.params.geoname);
        let roadcastcall = await api.roadcast.get(cityInfo.lat, cityInfo.lon);
        let result = await api.forecast.get(this.$route.params.geoname);
        let forecasts = result.short;
        let roadcasts = roadcastcall.roadcast["prediction-list"].prediction;



        forecasts = forecasts.filter((fcast) => {
          return fcast.timestamp * 1000 <= moment(roadcasts[roadcasts.length - 1]['roadcast-time']).unix() * 1000 
        });

        forecasts.forEach((fcast) => {
          let roadcast = roadcasts.find(
            (map) =>
              moment(moment(map["roadcast-time"]).unix() * 1000).format("YYYYMMDDHHmm") ==
              moment(fcast.timestamp * 1000).format("YYYYMMDDHHmm")
          );

          if (roadcast) {
            fcast.road_temp = roadcast.st;
            fcast.road_cond = roadcast.rc;
          }
          this.forecasts.push(fcast);
        });

        // this.forecasts = this.forecasts.filter(
        //   (fcast) =>
        //     moment(fcast.date).diff(
        //       this.forecasts3[this.forecasts3.length - 1].date
        //     ) <= 0
        // );
      } catch (err) {
        console.error(err.message);
      }
      this.loading = false;
      this.$nextTick(() => {
        if (this.$vuetify.breakpoint.mobile) {
          // this.$refs.highchart.chart.xAxis[0].setExtremes(0, 72, true,);
        }
      });
    },
    cardinals,

    syncExtremes: function (e) {
      var thisChart = this.chart;
      if (e.trigger !== "syncExtremes") {
        // Prevent feedback loop
        Highcharts.each(Highcharts.charts, function (chart) {
          if (chart !== thisChart) {
            if (chart.xAxis[0].setExtremes) {
              // It is null while updating
              chart.xAxis[0].setExtremes(e.min, e.max, undefined, false, {
                trigger: "syncExtremes",
              });
            }
          }
        });
      }
    },

    formatIcon(index) {
      if (this.forecasts[index].is_night) {
        return iconUrl(this.forecasts[index].ts, true);
      } else {
        return iconUrl(this.forecasts[index].ts);
      }
    },
  },

  setup() {
    const titleStack = ref(["Admin", "Prévisions"]);

    return {
      titleStack,
    };
  },

  mounted() {
    this.getForecasts();
  },
};
</script>

<style>
.highcharts-label.highcharts-data-label.highcharts-data-label-color-undefined.highcharts-tracker {
  top: 0 !important;
}
</style>
